import { RechtsformEnum } from '../v2024';

export const RechtsformEnumLabels = {
    NUMBER_200: 200 as RechtsformEnum,
    NUMBER_210: 210 as RechtsformEnum,
    NUMBER_220: 220 as RechtsformEnum,
    NUMBER_230: 230 as RechtsformEnum,
    NUMBER_270: 270 as RechtsformEnum,
    NUMBER_291: 291 as RechtsformEnum,
    NUMBER_310: 310 as RechtsformEnum,
    NUMBER_320: 320 as RechtsformEnum,
    NUMBER_350: 350 as RechtsformEnum,
    NUMBER_360: 360 as RechtsformEnum,
    NUMBER_370: 370 as RechtsformEnum,
    NUMBER_450: 450 as RechtsformEnum,
    NUMBER_991: 991 as RechtsformEnum
};

